import { API_REQUEST, GET_SUMMARY_DATA } from "../../actionTypes/actionsTypes";
import { AppAction } from "../../types";

export const getSummaryData = (profileType: string, snapshotId: string): AppAction => ({
  type: API_REQUEST,
  payload: {
    url: `/income/summary/${profileType}/${snapshotId}`,
    next: GET_SUMMARY_DATA,
    method: 'GET',
    authorization: true
  }
});